<div *ngIf="versions">
    <select class="select" [(ngModel)]="version" (ngModelChange)="onChange()">
        <option class="option" *ngFor="let version of versions">{{version}}</option>
    </select>
</div>
